import React from 'react';
import { Grid, List } from 'lucide-react';

interface ResultDensityControlsProps {
  viewMode: 'grid' | 'list';
  pageSize: number;
  onViewModeChange: (mode: 'grid' | 'list') => void;
  onPageSizeChange: (size: number) => void;
}

const ResultDensityControls: React.FC<ResultDensityControlsProps> = ({
  viewMode,
  pageSize,
  onViewModeChange,
  onPageSizeChange,
}) => {
  return (
    <div className="flex items-center justify-between mb-6 gap-4 flex-wrap">
      <div className="flex items-center gap-2">
        <label htmlFor="page-size" className="text-sm text-gray-700 whitespace-nowrap">
          Results per page:
        </label>
        <select
          id="page-size"
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          className="border border-gray-300 rounded-md px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-green-500 bg-white"
        >
          <option value={9}>9</option>
          <option value={12}>12</option>
          <option value={24}>24</option>
        </select>
      </div>

      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-700 mr-2">View:</span>
        <div className="inline-flex rounded-md shadow-sm" role="group" aria-label="View mode">
          <button
            type="button"
            onClick={() => onViewModeChange('grid')}
            className={`px-4 py-2 text-sm font-medium border border-gray-300 rounded-l-md focus:z-10 focus:outline-none focus:ring-2 focus:ring-green-500 transition-colors ${
              viewMode === 'grid'
                ? 'bg-green-600 text-white border-green-600'
                : 'bg-white text-gray-700 hover:bg-gray-50'
            }`}
            aria-pressed={viewMode === 'grid'}
            aria-label="Grid view"
          >
            <Grid className="w-4 h-4" />
          </button>
          <button
            type="button"
            onClick={() => onViewModeChange('list')}
            className={`px-4 py-2 text-sm font-medium border border-gray-300 rounded-r-md focus:z-10 focus:outline-none focus:ring-2 focus:ring-green-500 transition-colors ${
              viewMode === 'list'
                ? 'bg-green-600 text-white border-green-600'
                : 'bg-white text-gray-700 hover:bg-gray-50'
            }`}
            aria-pressed={viewMode === 'list'}
            aria-label="List view"
          >
            <List className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResultDensityControls;